/* src/pages/Nosotros.jsx */
import React from 'react';
import { MdPictureAsPdf } from 'react-icons/md';

import Redireccionar from '../components/Redireccionar';
// Si todavía quieres el componente de hero animado, impórtalo aquí
// import PresentacionPagina from '@/components/PresentacionPagina';

export default function Nosotros() {
  return (
    <main className="w-full flex flex-col items-center">
      {/* --- Hero (usa tu propio banner o PresentacionPagina) --- */}
      <section className="w-full group h-32 md:h-56 p-6 flex justify-center items-end bg-gray-900 relative overflow-hidden">
        <h1 className="z-10 text-xl sm:text-2xl md:text-4xl lg:text-5xl font-extrabold text-white group-hover:-translate-y-3 transition duration-500">
          QUIÉNES SOMOS
        </h1>
        <img
          src="https://img-cdn.hytera.com/iwov-resources/hytera/02_products/11_landing_page/en_subpage_banner_DMR_Radios.jpg_n.webp"
          alt="Banner Andes-TEC"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-purple-950 opacity-70" />
      </section>

      {/* --- Claim + Brochure PDF --- */}
      <section className="container flex flex-col sm:flex-row justify-between gap-4 pt-8">
        <h2 className="uppercase text-purple-900 font-extrabold text-sm sm:text-lg text-center sm:text-start">
          Expertos en comunicación profesional con tecnología Hytera
        </h2>

        <div className="sticky top-10">
          <a
            href="https://dps2wxsijib8x.cloudfront.net/pdf/BROCHURE%20ANDES-TEC%20.pdf"
            className="flex items-center gap-2 py-1 px-2 bg-purple-950 text-white rounded hover:bg-purple-900 transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MdPictureAsPdf className="text-xl" />
            Brochure Andes-TEC
          </a>
        </div>
      </section>

      {/* --- Texto descriptivo --- */}
      <section className="container py-4 space-y-4 text-base text-gray-700">
        <p>
          <strong>Andes-TEC</strong> es una empresa chilena especializada en
          soluciones avanzadas de radiocomunicación, enfocada principalmente en
          la implementación y soporte de equipos <strong>Hytera</strong>. Con
          más de <strong>10 años de experiencia</strong>, formamos parte del
          holding Inversiones E-Trading SpA y atendemos a empresas de distintas
          industrias en todo el país.
        </p>
        <p>
          Nuestro equipo asesora, comercializa e instala{' '}
          <strong>equipos de comunicación profesional</strong> en VHF y UHF,
          desarrollando soluciones personalizadas que integran tecnologías de
          vanguardia para mejorar la eficiencia operativa y la seguridad.
        </p>
        <p>
          Nos motiva ofrecer <strong>soporte técnico de calidad</strong> y
          mantener una relación cercana con nuestros clientes, garantizando una
          experiencia fluida en cada proyecto, desde necesidades simples hasta
          sistemas de misión crítica.
        </p>
      </section>

      {/* --- Misión · Visión · Valores --- */}
      <section className="container grid grid-cols-1 md:grid-cols-3 gap-4 px-8">
        {[
          {
            src: 'https://dps2wxsijib8x.cloudfront.net/imagenes-generales/nosotros/mision.webp',
            alt: 'Misión Andes-TEC',
          },
          {
            src: 'https://dps2wxsijib8x.cloudfront.net/imagenes-generales/nosotros/vision.webp',
            alt: 'Visión Andes-TEC',
          },
          {
            src: 'https://dps2wxsijib8x.cloudfront.net/imagenes-generales/nosotros/valores.webp',
            alt: 'Valores Andes-TEC',
          },
        ].map(({ src, alt }) => (
          <div
            key={alt}
            className="rounded-2xl flex items-center justify-center hover:shadow-md transition-transform duration-300"
          >
            <img
              src={src}
              alt={alt}
              loading="lazy"
              className="w-full h-auto object-contain max-w-xl rounded-2xl border-4 border-white"
            />
          </div>
        ))}
      </section>

      {/* --- Clientes destacados (recorta lista si es muy larga) --- */}
      <section className="container py-8">
        <h2 className="uppercase text-purple-900 font-extrabold border-l-4 border-purple-800 pl-4 text-base sm:text-lg">
          Nuestros clientes
        </h2>
        <p className="text-gray-700 text-sm sm:text-base py-2">
          Desarrollamos soluciones de calidad para múltiples industrias,
          integrando tecnología de última generación y soporte experto.
        </p>

        <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-7 gap-4 bg-gray-100 p-6 rounded-lg">
          {[
            'abengoa',
            'aes',
            'arcadis',
            'atco',
            'banco-central',
            'belfi',
            'besalco',
            'bureau',
            'cmpc',
            'colas-retail',
            'dgac-chile',
            'dipisa',
            'eiffage-energia',
            'eliansa',
            'fast-pack',
            'ferpi',
            'ingenieria-construccion',
            'lo-valledor',
          ].map((slug) => (
            <div
              key={slug}
              className="h-24 p-2 hover:scale-110 transition-transform"
            >
              <img
                src={`https://dps2wxsijib8x.cloudfront.net/imagenes-generales/clientes/${slug}.webp`}
                alt={`${slug} logo`}
                loading="lazy"
                className="w-full h-full object-contain"
              />
            </div>
          ))}
        </div>
      </section>

      {/* --- CTA: Explora nuestras especialidades --- */}
      <section className="container pb-12">
        <h2 className="uppercase text-purple-900 font-extrabold py-2 text-base sm:text-lg">
          Explora nuestras especialidades
        </h2>

        <div className="flex flex-col gap-4">
          <Redireccionar
            titulo="Arriendo de radios comunicacionales"
            descripcion="Variedad de radios profesionales para eventos,
                        seguridad y operaciones industriales. Soporte técnico garantizado."
            imagen="https://dps2wxsijib8x.cloudfront.net/arriendo-radios-web/banner/RedireccionBanner.webp"
            enlace="https://www.andes-tec.cl"
          />

          <Redireccionar
            titulo="Bodycam para profesionales"
            descripcion="Cámaras corporales Hytera para fuerzas del orden y
                        seguridad privada. Transparencia y recolección de evidencia."
            imagen="https://dps2wxsijib8x.cloudfront.net/bodycam/bodycam-banner.jpeg"
            enlace="https://www.bodycam.cl"
          />

          <Redireccionar
            titulo="Equipos POC (Push-to-Talk over Cellular)"
            descripcion="Comunicación inmediata sin las limitaciones de un sistema
                        de radios tradicional. Cobertura nacional, coordinación en tiempo real."
            imagen="https://www.hytera.com/iwov-resources/hytera/17_campaign/en_PTC680_MDM.jpg"
            enlace="https://www.pocradios.cl"
          />
        </div>
      </section>
    </main>
  );
}
